<div class="modal-header">
  <h4 class="modal-title">Edit Filters</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="form-group clearfix">
    <button type="button" class="btn btn-primary float-right ml-2"
            (click)="handleSubmit()">
      Apply
    </button>
    <button type="button" class="btn btn-secondary float-right"
            (click)="handleClearAll()">
      Clear All
    </button>
  </div>

  <hr>

  <app-date-range-filter
    [label]="'Created Date'"
    [idPrefix]="'created_at'"
    [(min)]="filters.created_at_min"
    [(max)]="filters.created_at_max"
    [(range)]="filters.created_at_range">
    <small class="form-text text-muted">
      When the customer was added to the inbox.
    </small>
  </app-date-range-filter>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.customer_id = undefined;">
      Clear
    </button>

    <label for="customer_id" class="d-block">Customer ID</label>
    <input class="form-control w-50" id="customer_id" name="customer_id"
           type="number"
           [(ngModel)]="filters.customer_id">
  </div>

  <hr>

  <div class="form-group">
    <label for="is_resolved" class="d-block">Status</label>
    <select class="custom-select w-50" id="is_resolved" name="is_resolved"
            [(ngModel)]="filters.is_resolved">
      <option [ngValue]="false">Unresolved</option>
      <option [ngValue]="true">Resolved</option>
    </select>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.inbox_id = undefined;">
      Clear
    </button>

    <label for="inbox_id">Inbox</label>
    <select class="custom-select w-100" id="inbox_id" name="inbox_id"
            [(ngModel)]="filters.inbox_id">
      <option [ngValue]="undefined">All Custom Inboxes</option>
      <option *ngIf="selectedInboxInactive()" [ngValue]="filters.inbox_id">
        {{ selectedInboxDisplay() }}
      </option>
      <option *ngFor="let inbox of activeInboxes" [ngValue]="inbox.id">
        {{ inbox.name }}
      </option>
    </select>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="handleClearAll()">
    Clear All
  </button>
  <button type="button" class="btn btn-primary"
          (click)="handleSubmit()">
    Apply
  </button>
</div>
